




import Vue from 'vue';

export default Vue.extend({
	data() {
		return {
			showReceptionIframe: true,
		};
	},
	computed: {
		wmsReceptionUrl() {
			return `${this.dmsSys.DMSC_url}/wms/WmsReception`;
		},
	},
});
